@for (product of products; track $index) {
<app-product-list-item
  [data]="product"
  appSlideup
  [slideUpDelay]="$index*50"
  [slideUpMaxDelay]="250"
  [onIntersection]="true"
></app-product-list-item>
}
